import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Div = styled.div`
  display: grid;
  font-family: Alegreya, serif;
  font-weight: normal;
  height: calc(100vh - 100px);
  opacity: 1;
  position: absolute;
  text-align: left;
  top: 100px;
  width: 100%;
  z-index: 1000;
  grid-template-columns: ${({ quotePosition }) => `${ quotePosition.left } auto ${ quotePosition.right }` };
  grid-template-rows: ${({ quotePosition }) => `${ quotePosition.top } auto ${ quotePosition.bottom }` };

  @media (max-width: 600px) {
    display: block !important;
    padding: 20px;
    top: 30px;
  }

  .auto-grid {
    
  }

  p:before {
    content: '\\2014';
    padding-right: 5px;
  }

  h3 {
    font-size: 1em;
    font-style: italic;
    font-weight: normal;
    line-height: 1.5em;

    @media (min-width: 600px) {
      font-size: 1.7em;
    }
  }
`;

const Grid = styled.div`
  justify-self: ${({ quotePosition }) => quotePosition.justifySelf };
  align-self: ${({ quotePosition }) => quotePosition.alignSelf };
  grid-column-start: 2;
  grid-row-start: 2;
`;


const Quote = ({ citation, quote, quotePosition, quoteColor }) => {

  return (
      <Div quotePosition={ quotePosition } className="quote">
        <Grid quotePosition={ quotePosition } className="auto-grid">
          <div>
          <h3 style={ { color: quoteColor } }>{ quote }</h3>
          <p style={ { color: quoteColor } }>{ citation }</p>
          </div>
      </Grid>
      </Div>
  );
};

Quote.propTypes = {
  citation: PropTypes.string,
  quote: PropTypes.string,
  quotePosition: PropTypes.object,
  quoteColor: PropTypes.string
};

export default Quote;



// WEBPACK FOOTER //
// ./src/components/Quote/index.js